import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { G1ListComponent } from './list/g1-list/g1-list.component';
import { G1AccessComponent } from './access/g1-access/g1-access.component';
import { H1AccessComponent } from './access/h1-access/h1-access.component';
import { H2AccessComponent } from './access/h2-access/h2-access.component';
import { H3AccessComponent } from './access/h3-access/h3-access.component';
import { HomeComponent } from './home/home.component';
import { G2AccessComponent } from './access/g2-access/g2-access.component';
import { G2ListComponent } from './list/g2-list/g2-list.component';
import { G3AccessComponent } from './access/g3-access/g3-access.component';
import { G4AccessComponent } from './access/g4-access/g4-access.component';
import { S1AccessComponent } from './access/s1-access/s1-access.component';
import { S2AccessComponent } from './access/s2-access/s2-access.component';
import { S3AccessComponent } from './access/s3-access/s3-access.component';
import { S4AccessComponent } from './access/s4-access/s4-access.component';
import { S5AccessComponent } from './access/s5-access/s5-access.component';
import { S6AccessComponent } from './access/s6-access/s6-access.component';
import { S7AccessComponent } from './access/s7-access/s7-access.component';
import { S8AccessComponent } from './access/s8-access/s8-access.component';
import { S9AccessComponent } from './access/s9-access/s9-access.component';
import { S10AccessComponent } from './access/s10-access/s10-access.component';
import { S11AccessComponent } from './access/s11-access/s11-access.component';
import { S12AccessComponent } from './access/s12-access/s12-access.component';
import { S13AccessComponent } from './access/s13-access/s13-access.component';
import { S14AccessComponent } from './access/s14-access/s14-access.component';
import { S15AccessComponent } from './access/s15-access/s15-access.component';
import { S16AccessComponent } from './access/s16-access/s16-access.component';
import { S17AccessComponent } from './access/s17-access/s17-access.component';
import { S18AccessComponent } from './access/s18-access/s18-access.component';
import { S19AccessComponent } from './access/s19-access/s19-access.component';
import { S20AccessComponent } from './access/s20-access/s20-access.component';
import { S21AccessComponent } from './access/s21-access/s21-access.component';
import { S22AccessComponent } from './access/s22-access/s22-access.component';
import { S23AccessComponent } from './access/s23-access/s23-access.component';
import { S24AccessComponent } from './access/s24-access/s24-access.component';
import { S25AccessComponent } from './access/s25-access/s25-access.component';
import { S26AccessComponent } from './access/s26-access/s26-access.component';
import { S27AccessComponent } from './access/s27-access/s27-access.component';
import { S28AccessComponent } from './access/s28-access/s28-access.component';
import { S29AccessComponent } from './access/s29-access/s29-access.component';
import { S30AccessComponent } from './access/s30-access/s30-access.component';
import { S31AccessComponent } from './access/s31-access/s31-access.component';
import { S32AccessComponent } from './access/s32-access/s32-access.component';
import { S33AccessComponent } from './access/s33-access/s33-access.component';
import { S34AccessComponent } from './access/s34-access/s34-access.component';
import { S35AccessComponent } from './access/s35-access/s35-access.component';
import { G3ListComponent } from './list/g3-list/g3-list.component';
import { G4ListComponent } from './list/g4-list/g4-list.component';
import { H1ListComponent } from './list/h1-list/h1-list.component';
import { H2ListComponent } from './list/h2-list/h2-list.component';
import { S1ListComponent } from './list/s1-list/s1-list.component';
import { S2ListComponent } from './list/s2-list/s2-list.component';
import { S3ListComponent } from './list/s3-list/s3-list.component';
import { S4ListComponent } from './list/s4-list/s4-list.component';
import { S5ListComponent } from './list/s5-list/s5-list.component';
import { S6ListComponent } from './list/s6-list/s6-list.component';
import { S7ListComponent } from './list/s7-list/s7-list.component';
import { S8ListComponent } from './list/s8-list/s8-list.component';
import { S9ListComponent } from './list/s9-list/s9-list.component';
import { S10ListComponent } from './list/s10-list/s10-list.component';
import { S11ListComponent } from './list/s11-list/s11-list.component';
import { S12ListComponent } from './list/s12-list/s12-list.component';
import { S13ListComponent } from './list/s13-list/s13-list.component';
import { S14ListComponent } from './list/s14-list/s14-list.component';
import { S15ListComponent } from './list/s15-list/s15-list.component';
import { S16ListComponent } from './list/s16-list/s16-list.component';
import { S17ListComponent } from './list/s17-list/s17-list.component';
import { S18ListComponent } from './list/s18-list/s18-list.component';
import { S19ListComponent } from './list/s19-list/s19-list.component';
import { S20ListComponent } from './list/s20-list/s20-list.component';
import { S21ListComponent } from './list/s21-list/s21-list.component';
import { S22ListComponent } from './list/s22-list/s22-list.component';
import { S23ListComponent } from './list/s23-list/s23-list.component';
import { S24ListComponent } from './list/s24-list/s24-list.component';
import { S25ListComponent } from './list/s25-list/s25-list.component';
import { S26ListComponent } from './list/s26-list/s26-list.component';
import { S27ListComponent } from './list/s27-list/s27-list.component';
import { S28ListComponent } from './list/s28-list/s28-list.component';
import { S29ListComponent } from './list/s29-list/s29-list.component';
import { S30ListComponent } from './list/s30-list/s30-list.component';
import { S31ListComponent } from './list/s31-list/s31-list.component';
import { S32ListComponent } from './list/s32-list/s32-list.component';
import { S33ListComponent } from './list/s33-list/s33-list.component';
import { S34ListComponent } from './list/s34-list/s34-list.component';
import { S35ListComponent } from './list/s35-list/s35-list.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'g1-access',
    component: G1AccessComponent
  },
  {
    path: 'g2-access',
    component: G2AccessComponent,
  },
  {
    path: 'g3-access',
    component: G3AccessComponent,
  },
  {
    path: 'g4-access',
    component: G4AccessComponent,
  },
  {
    path: 'h1-access',
    component: H1AccessComponent
  },
  {
    path: 'h2-access',
    component: H2AccessComponent
  },
  {
    path: 'h3-access',
    component: H3AccessComponent
  },
  {
    path: 's1-access',
    component: S1AccessComponent,
  },
  {
    path: 's2-access',
    component: S2AccessComponent,
  },
  {
    path: 's3-access',
    component: S3AccessComponent,
  },
  {
    path: 's4-access',
    component: S4AccessComponent,
  },
  {
    path: 's5-access',
    component: S5AccessComponent,
  },
  {
    path: 's6-access',
    component: S6AccessComponent,
  },
  {
    path: 's7-access',
    component: S7AccessComponent,
  },
  {
    path: 's8-access',
    component: S8AccessComponent,
  },
  {
    path: 's9-access',
    component: S9AccessComponent,
  },
  {
    path: 's10-access',
    component: S10AccessComponent,
  },
  {
    path: 's11-access',
    component: S11AccessComponent,
  },
  {
    path: 's12-access',
    component: S12AccessComponent,
  },
  {
    path: 's13-access',
    component: S13AccessComponent,
  },
  {
    path: 's14-access',
    component: S14AccessComponent,
  },
  {
    path: 's15-access',
    component: S15AccessComponent,
  },
  {
    path: 's16-access',
    component: S16AccessComponent,
  },
  {
    path: 's17-access',
    component: S17AccessComponent,
  },
  {
    path: 's18-access',
    component: S18AccessComponent,
  },
  {
    path: 's19-access',
    component: S19AccessComponent,
  },
  {
    path: 's20-access',
    component: S20AccessComponent,
  },
  {
    path: 's21-access',
    component: S21AccessComponent,
  },
  {
    path: 's22-access',
    component: S22AccessComponent,
  },
  {
    path: 's23-access',
    component: S23AccessComponent,
  },
  {
    path: 's24-access',
    component: S24AccessComponent,
  },
  {
    path: 's25-access',
    component: S25AccessComponent,
  },
  {
    path: 's26-access',
    component: S26AccessComponent,
  },
  {
    path: 's27-access',
    component: S27AccessComponent,
  },
  {
    path: 's28-access',
    component: S28AccessComponent,
  },
  {
    path: 's29-access',
    component: S29AccessComponent,
  },
  {
    path: 's30-access',
    component: S30AccessComponent,
  },
  {
    path: 's31-access',
    component: S31AccessComponent,
  },
  {
    path: 's32-access',
    component: S32AccessComponent,
  },
  {
    path: 's33-access',
    component: S33AccessComponent,
  },
  {
    path: 's34-access',
    component: S34AccessComponent,
  },
  {
    path: 's35-access',
    component: S35AccessComponent,
  },
  {
    path: 'g1-list',
    component: G1ListComponent,
  },
  {
    path: 'g2-list',
    component: G2ListComponent,
  },
  {
    path: 'g3-list',
    component: G3ListComponent,
  },
  {
    path: 'g4-list',
    component: G4ListComponent,
  },
  {
    path: 'h1-list',
    component: H1ListComponent,
  },
  {
    path: 'h2-list',
    component: H2ListComponent,
  },
  {
    path: 's1-list',
    component: S1ListComponent,
  },
  {
    path: 's2-list',
    component: S2ListComponent,
  },
  {
    path: 's3-list',
    component: S3ListComponent,
  },
  {
    path: 's4-list',
    component: S4ListComponent,
  },
  {
    path: 's5-list',
    component: S5ListComponent,
  },
  {
    path: 's6-list',
    component: S6ListComponent,
  },
  {
    path: 's7-list',
    component: S7ListComponent,
  },
  {
    path: 's8-list',
    component: S8ListComponent,
  },
  {
    path: 's9-list',
    component: S9ListComponent,
  },
  {
    path: 's10-list',
    component: S10ListComponent,
  },
  {
    path: 's11-list',
    component: S11ListComponent,
  },
  {
    path: 's12-list',
    component: S12ListComponent,
  },
  {
    path: 's13-list',
    component: S13ListComponent,
  },
  {
    path: 's14-list',
    component: S14ListComponent,
  },
  {
    path: 's15-list',
    component: S15ListComponent,
  },
  {
    path: 's16-list',
    component: S16ListComponent,
  },
  {
    path: 's17-list',
    component: S17ListComponent,
  },
  {
    path: 's18-list',
    component: S18ListComponent,
  },
  {
    path: 's19-list',
    component: S19ListComponent,
  },
  {
    path: 's20-list',
    component: S20ListComponent,
  },
  {
    path: 's21-list',
    component: S21ListComponent,
  },
  {
    path: 's22-list',
    component: S22ListComponent,
  },
  {
    path: 's23-list',
    component: S23ListComponent,
  },
  {
    path: 's24-list',
    component: S24ListComponent,
  },
  {
    path: 's25-list',
    component: S25ListComponent,
  },
  {
    path: 's26-list',
    component: S26ListComponent,
  },
  {
    path: 's27-list',
    component: S27ListComponent,
  },
  {
    path: 's28-list',
    component: S28ListComponent,
  },
  {
    path: 's29-list',
    component: S29ListComponent,
  },
  {
    path: 's30-list',
    component: S30ListComponent,
  },
  {
    path: 's31-list',
    component: S31ListComponent,
  },
  {
    path: 's32-list',
    component: S32ListComponent,
  },
  {
    path: 's33-list',
    component: S33ListComponent,
  },
  {
    path: 's34-list',
    component: S34ListComponent,
  },
  {
    path: 's35-list',
    component: S35ListComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
